module.exports = __webpack_public_path__ + "static/media/wifi.cb65344f.svg";